<div [class.scroll]="!integrated">

    <ng-container *ngIf="!integrated">
        <h2 class="block-title">{{question.label}}</h2>
        <p class="paragraph-13" *ngIf="question.description">{{question.description}}</p>
    </ng-container>

    <ion-list>
        <ion-item *ngFor="let element of elements, let i = index" lines="none">
            <ion-label slot="start" class="paragraph-15">
                {{element.label}}
            </ion-label>
            <ion-label slot="end" class="content-title ion-text-right">
                <div *ngIf="element.oldValue == null">
                    {{element.value}}{{options.unit}}
                    <ion-icon *ngIf="!readOnly" class="icon haleo-trash" (click)="remove(i)"></ion-icon>
                </div>
                <div *ngIf="element.oldValue != null && element.value == null">
                    {{element.oldValue}}{{options.unit}}
                    <ion-icon *ngIf="!readOnly" class="icon edit haleo-slice" (click)="update(element)"></ion-icon>
                </div>
                <div *ngIf="element.oldValue != null && element.value != null">
                    <span class="old">{{element.oldValue}}{{options.unit}}</span>
                    <span>{{element.value}}{{options.unit}}</span>
                    <ion-icon *ngIf="!readOnly" class="icon edit haleo-slice" (click)="update(element)"></ion-icon>
                </div>
            </ion-label>
        </ion-item>
    </ion-list>

    <ion-button *ngIf="!readOnly" class="add" expand="block" fill="outline" color="primary" (click)="addElement()">
        <ion-icon slot="start" class="icon haleo-plus"></ion-icon>
        {{'thoughtRecord.assessment.addEmotion' | translate}}
    </ion-button>
</div>

<ng-container *ngIf="!integrated">
    <ion-button class="continue" color="secondary" [disabled]="!elements || elements.length == 0" (click)="continue()">
        {{'thoughtRecord.assessment.continue' | translate}}
    </ion-button>
</ng-container>
